import React from 'react';
import { Link } from 'react-router-dom';
import {
    Alert,
    Box,
    Button,
    Paper,
    Stack,
    Typography
} from '@mui/material';

class RouteErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({
                hasError: false,
                error: null
            });
        }
    }

    componentDidCatch(error, errorInfo) {
        console.error('Route render failed:', {
            pageName: this.props.pageName,
            error,
            componentStack: errorInfo?.componentStack
        });
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        const { pageName, showAdminDetails } = this.props;
        const errorName = this.state.error?.name || 'Render error';

        return (
            <Paper sx={{ p: 3, maxWidth: 760 }}>
                <Stack spacing={2}>
                    <Alert severity="error">
                        <Typography variant="h6" gutterBottom>
                            This page failed to load.
                        </Typography>
                        <Typography variant="body2">
                            Try refreshing, or contact admin.
                        </Typography>
                    </Alert>

                    {showAdminDetails && (
                        <Box>
                            <Typography variant="body2" color="text.secondary">
                                Page: {pageName || 'Unknown page'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {errorName}
                            </Typography>
                        </Box>
                    )}

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
                        <Button component={Link} to="/dashboard" variant="contained">
                            Back to Dashboard
                        </Button>
                        <Button variant="outlined" onClick={() => window.location.reload()}>
                            Reload Page
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        );
    }
}

export default RouteErrorBoundary;
